// extracted by mini-css-extract-plugin
module.exports = {"layoutSpacing":"styles_layoutSpacing__TE6jA"};